import { render, staticRenderFns } from "./labeled-value.vue?vue&type=template&id=4f09a0c6"
import script from "./labeled-value.vue?vue&type=script&lang=js"
export * from "./labeled-value.vue?vue&type=script&lang=js"
import style0 from "./labeled-value.vue?vue&type=style&index=0&id=4f09a0c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports